import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AddAnnulationMotifModal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "addRejetModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
          _createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Motif de rejet d'une demande")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            ref: "rejetForm",
            onSubmit: $setup.addAnnulation,
            "validation-schema": $setup.rejetSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Motif "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "motif",
                      cols: "30",
                      rows: "5",
                      as: "textarea",
                      placeholder: "Ecrire votre motif ici",
                      class: "form-control shadow-none rounded-0 text-black"
                    }, {
                      default: _withCtx(({ field }) => [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          class: "form-control shadow-none rounded-0 text-black"
                        }, null, 8, _hoisted_8), [
                          [_vModelText, field.value]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "motif",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("button", {
                class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
                type: "submit"
              }, " Rejetée ", -1))
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.resetValue()))
        })
      ])
    ])
  ], 512))
}